export const reactSelectCustomStyles = {
  control: (base, state) => ({
    ...base,
    // borderColor: "#84d8e2",
    boxShadow: "#c93636",
    // "&:hover": {
    //   borderColor: "#84d8e2",
    // },
    height: "35px",
    "min-height": "35px",
    "&:focus-within": {
      borderColor: "#626ed4",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: state.isSelected ? "#626ed4" : "inherit",
    "&:hover": {
      backgroundColor: state.isSelected ? "#626ed4" : "rgb(222, 235, 255)",
    },
  }),
}
// 36C95F
